import { MBox, MText } from '..';

export function LookupTriggerContent({
  displayLabel,
  value,
  hideRecordId = false,
}: {
  displayLabel?: string;
  value: string;
  /**
   * Renders `displayLabel` on its own, without the record id beneath it. For
   * single-line contexts where the id would add a second line — the popover
   * still shows it. Ignored when there is no `displayLabel`, since the id is
   * then the only thing identifying the record.
   */
  hideRecordId?: boolean;
}) {
  if (displayLabel) {
    return (
      <MBox as="span" display="block">
        <MText
          as="span"
          display="block"
          fontWeight="500"
          whiteSpace="normal"
          color={hideRecordId ? 'inherit' : undefined}
        >
          {displayLabel}
        </MText>
        {!hideRecordId && (
          <MText
            as="span"
            display="block"
            whiteSpace="normal"
            fontSize="sm"
            color="tIndigo.base"
          >
            {value}
          </MText>
        )}
      </MBox>
    );
  }
  return <>{value}</>;
}
